import React from 'react';
import { Link } from 'react-router-dom';
import mobilierImage from '../images/mobilier-square.jpg';
import horlogerieImage from '../images/montres-square.jpg';
import bijouxImage from '../images/bijoux-square.png';
import jouetsImage from '../images/jouets-square.png';
import militaireImage from '../images/militaire-square.png';
import artImage from '../images/tableaux-square.jpg';
import porcelaineImage from '../images/ceramique-square.png';
import tapisserieImage from '../images/tapis.JPG';
import artAsiatiquesImage from '../images/asiat-square.png';
import sculptureImage from '../images/sculpture-square.jpg';
import argenterieImage from '../images/argenterie-square.png';
import instrumentsImage from '../images/musique-square.png';
import vinsImage from '../images/vin-square.png';
import maroquinerieImage from '../images/IMG_20250301_154853.png'
import monnaieImage from '../images/monnaie-square.png';
import fourruresImage from '../images/IMG_20250301_154746.png';

function ObjetsPage() {
    const items = [
        {
            name: 'Meubles anciens',
            image: mobilierImage,
            path: '/mobilier',
            desc:
                'Nous rachetons vos meubles de tout style et toute époque en chêne, noyer ou bois exotiques (secrétaires, commodes, bureaux, marqueteries, etc.).',
        },
        {
            name: 'Fourrures',
            image: fourruresImage,
            path: '/fourrures',
            desc:
                'Vison, astrakan, marmotte, renard, lapin, etc. Nous estimons et rachetons vos fourrures et vêtements de luxe.',
        },
        {
            name: 'Bijoux joaillerie ancienne',
            image: bijouxImage,
            path: '/bijoux',
            desc:
                'Bagues, bracelets, boucles d’oreilles, colliers, alliances… même abîmés ou cassés.',
        },
        {
            name: 'Anciens Sacs à main & Bagages de luxe',
            image: maroquinerieImage,
            path: '/sacs-bagages',
            desc:
                'Sacs à main anciens et de créateurs ainsi que bagages de luxe (Hermès, Dior, Chanel, etc.).',
        },
        {
            name: 'Horlogerie',
            image: horlogerieImage,
            path: '/horlogerie',
            desc:
                'Montres-bracelets, goussets, pendules et horloges de toutes époques et marques.',
        },
        {
            name: 'Arts décoratifs & Tableaux',
            image: artImage,
            path: '/art',
            desc:
                'Peintures, dessins, gravures et objets d’art. Écoles et périodes variées.',
        },
        {
            name: 'Céramique & Pâtes de verre',
            image: porcelaineImage,
            path: '/porcelaine',
            desc:
                'Faïence, porcelaine, grès, pâte de verre, pièces signées et services anciens.',
        },
        {
            name: 'Tapisserie',
            image: tapisserieImage,
            path: '/tapisserie',
            desc:
                'Tapis, kilims, tapisseries murales et textiles anciens.',
        },
        {
            name: 'Arts asiatiques',
            image: artAsiatiquesImage,
            path: '/arts-asiatiques',
            desc:
                'Bronzes, porcelaines, laques, estampes et objets de Chine, Japon, Corée…',
        },
        {
            name: 'Sculpture',
            image: sculptureImage,
            path: '/sculpture',
            desc:
                'Bois, marbre, bronze, terre cuite — œuvres figuratives et abstraites.',
        },
        {
            name: 'Argenterie',
            image: argenterieImage,
            path: '/argenterie',
            desc:
                'Argent massif ou plaqué, couverts, pièces de service, objets signés.',
        },
        {
            name: 'Instruments de musique',
            image: instrumentsImage,
            path: '/instrument-de-musique',
            desc:
                'Cordes, vents, claviers, lutherie ancienne et moderne.',
        },
        {
            name: 'Vins & Spiritueux',
            image: vinsImage,
            path: '/vin-et-spiritueux',
            desc:
                'Bouteilles anciennes, grands crus, cognacs et whiskies de collection.',
        },
        {
            name: 'Militaria',
            image: militaireImage,
            path: '/militaire',
            desc:
                'Uniformes, décorations, sabres, souvenirs historiques et documents.',
        },
        {
            name: 'Monnaies & Médailles',
            image: monnaieImage,
            path: '/monnaie',
            desc:
                'Pièces, billets, médailles, jetons — collections et héritages.',
        },
        {
            name: 'Jouets & Jeux anciens',
            image: jouetsImage,
            path: '/jouets',
            desc:
                'Jouets anciens, miniatures, trains, poupées et jeux de société.',
        },
    ];

    return (
        <div className="page">
            <header className="intro">
                <h2>Objets</h2>
                <p>
                    Découvrez les catégories d’objets que j’achète et évalue. Chaque pièce
                    a une histoire et une valeur à préserver. Cliquez sur une carte pour en
                    savoir plus ou demander une estimation.
                </p>
            </header>

            <div className="masonry">
                {items.map((item, i) => (
                    <article className="masonry-item" key={i}>
                        <Link to={item.path} className="card" aria-label={item.name}>
                            <div className="media">
                                <img src={item.image} alt={item.name} loading="lazy" />
                            </div>
                            <div className="info">
                                <h3>{item.name}</h3>
                                {item.desc && <p>{item.desc}</p>}
                            </div>
                        </Link>
                    </article>
                ))}
            </div>

            <style jsx>{`
        .page {
          padding: 48px 24px 80px;
          background: #f2f5f7;
        }

        .intro {
          max-width: 1100px;
          margin: 0 auto 28px;
          text-align: left;
        }

        .intro h2 {
          font-size: 2.6rem;
          line-height: 1.1;
          margin: 0 0 12px;
          color: #1f2b2a;
          letter-spacing: -0.02em;
        }

        .intro p {
          max-width: 820px;
          font-size: 1.1rem;
          line-height: 1.75;
          color: #44504f;
          margin: 0;
        }

        .masonry {
          column-count: 4;
          column-gap: 28px;
          max-width: 1200px;
          margin: 28px auto 0;
        }

        @media (max-width: 1200px) {
          .masonry { column-count: 3; }
        }
        @media (max-width: 900px) {
          .masonry { column-count: 2; }
        }
        @media (max-width: 600px) {
          .masonry { 
            column-count: 1;
            max-width: 400px;
          }
        }

        .masonry-item {
          break-inside: avoid;
          margin-bottom: 28px;
        }

        .card {
          display: block;
          color: inherit;
          text-decoration: none;
          border-radius: 18px;
          overflow: visible;
          position: relative;
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }

        .card:hover {
          transform: translateY(-4px);
        }

        .media {
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          background: #e6eaed;
        }

        .media img {
          width: 100%;
          height: 420px;
          object-fit: cover;
          display: block;
          transition: transform 0.35s ease;
        }

        .card:hover .media img {
          transform: scale(1.03);
        }

        .info {
          position: relative;
          margin: -56px 24px 0;
          background: #fff;
          border-radius: 12px;
          padding: 20px 22px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
        }

        .info h3 {
          margin: 0 0 8px;
          font-weight: 600;
          font-size: 1.35rem;
          line-height: 1.3;
          color: #263433;
        }

        .info p {
          margin: 0;
          font-size: 0.98rem;
          line-height: 1.65;
          color: #5b6665;
        }

        @media (max-width: 768px) {
          .page {
            padding: 80px 16px 60px;
          }

          .intro {
            margin-bottom: 32px;
            text-align: center;
          }

          .intro h2 {
            font-size: 2.2rem;
            margin-bottom: 16px;
          }

          .intro p {
            font-size: 1.05rem;
            max-width: 100%;
          }

          .masonry {
            margin-top: 32px;
            column-gap: 20px;
          }

          .masonry-item {
            margin-bottom: 24px;
          }

          .media img {
            height: 300px;
          }

          .info {
            margin: -40px 16px 0;
            padding: 18px 20px;
            border-radius: 16px;
          }

          .info h3 {
            font-size: 1.25rem;
            margin-bottom: 10px;
          }

          .info p {
            font-size: 0.95rem;
            line-height: 1.6;
          }
        }

        @media (max-width: 480px) {
          .page {
            padding: 100px 12px 48px;
          }

          .intro {
            margin-bottom: 24px;
          }

          .intro h2 {
            font-size: 1.9rem;
          }

          .intro p {
            font-size: 1rem;
            line-height: 1.6;
          }

          .masonry {
            margin-top: 24px;
            column-gap: 16px;
            max-width: 350px;
          }

          .masonry-item {
            margin-bottom: 20px;
          }

          .card {
            border-radius: 16px;
          }

          .media {
            border-radius: 16px;
          }

          .media img {
            height: 250px;
          }

          .info {
            margin: -32px 12px 0;
            padding: 16px 18px;
            border-radius: 12px;
            box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          }

          .info h3 {
            font-size: 1.15rem;
            margin-bottom: 8px;
            line-height: 1.2;
          }

          .info p {
            font-size: 0.9rem;
            line-height: 1.5;
          }

          .card:hover {
            transform: translateY(-2px);
          }

          .card:hover .media img {
            transform: scale(1.01);
          }
        }

        @media (max-width: 360px) {
          .page {
            padding: 120px 8px 40px;
          }

          .masonry {
            max-width: 320px;
          }

          .media img {
            height: 220px;
          }

          .info {
            margin: -28px 8px 0;
            padding: 14px 16px;
          }

          .info h3 {
            font-size: 1.1rem;
          }

          .info p {
            font-size: 0.85rem;
          }
        }
      `}</style>
        </div>
    );
}

export default ObjetsPage;
